<div class="hc-alert-container">
  @for (alert of alerts; track trackById($index, alert)) {
    <div
      class="hc-alert"
      [class.hc-alert--success]="alert.type === 'success'"
      [class.hc-alert--danger]="alert.type === 'danger'"
      [class.hc-alert--warning]="alert.type === 'warning'"
      [class.hc-alert--info]="alert.type === 'info'"
      role="alert"
      >
      <!-- Icon -->
      <lucide-icon class="hc-alert__icon" [name]="getIcon(alert.type)"></lucide-icon>
      <!-- Content -->
      <div class="hc-alert__content">
        @if (alert.title) {
          <div class="hc-alert__title">{{ alert.title }}</div>
        }
        <div class="hc-alert__message">{{ alert.message }}</div>
      </div>
      <!-- Action Button -->
      @if (alert.action) {
        <button
          type="button"
          class="hc-alert__action"
          (click)="onActionClick(alert)"
          >
          {{ alert.action.label }}
        </button>
      }
      <!-- Dismiss Button -->
      @if (alert.dismissible) {
        <button
          type="button"
          class="hc-alert__dismiss"
          (click)="dismiss(alert.id)"
          aria-label="Dismiss"
          >
          <lucide-icon name="x"></lucide-icon>
        </button>
      }
    </div>
  }
</div>
